import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { GalleryBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Image Gallery 3",
  version: 1,
  nameI18n: "builder_ui.block_type.image_gallery_block_3",
  category: [GalleryBlock],
  props: {
    headerContent: {
      name: "Header",
      nameI18n: "builder_ui.prop_type.header",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    imageNode1: {
      name: "Image 1",
      nameI18n: "settings.emails.visual_builder.prop_type.image_1",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    imageNode2: {
      name: "Image 2",
      nameI18n: "settings.emails.visual_builder.prop_type.image_2",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    imageNode3: {
      name: "Image 3",
      nameI18n: "settings.emails.visual_builder.prop_type.image_3",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    imageNode4: {
      name: "Image 4",
      nameI18n: "settings.emails.visual_builder.prop_type.image_4",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    imageNode5: {
      name: "Image 5",
      nameI18n: "settings.emails.visual_builder.prop_type.image_5",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    imageNode6: {
      name: "Image 6",
      nameI18n: "settings.emails.visual_builder.prop_type.image_6",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    imageNode7: {
      name: "Image 7",
      nameI18n: "settings.emails.visual_builder.prop_type.image_7",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    imageNode8: {
      name: "Image 8",
      nameI18n: "settings.emails.visual_builder.prop_type.image_8",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    imageNode9: {
      name: "Image 9",
      nameI18n: "settings.emails.visual_builder.prop_type.image_9",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        backgroundColor: {
          ...backgroundColor,
          type: "color-without-alpha",
          nameI18n:
            "settings.emails.visual_builder.prop_type.styles.background_color",
          defaultValue: defaultStyles.backgroundColor,
          category: [DesignProp, GeneralProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
      },
    },
  },
};
